// COMMON

export const USER = 'user';
export const AUTH = 'auth';
export const WISHLIST = 'wishlist';

// USERS

export const FRIENDS = 'friends';

// ITEMS

export const FEED = 'feed';

// FRIENDSHIPS

export const RECEIVED = 'requests';
